import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { cursoI } from 'src/app/shared/models/curso.interface';
import { CursoService } from 'src/app/servicios/curso.service';

@Component({
  selector: 'app-noticias',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.scss']
})
export class NoticiasComponent implements OnInit {

  public cursos$:Observable<cursoI[]>

 

  constructor(private cursoSvc:CursoService) { }

  ngOnInit(): void {
    this.cursos$ = this.cursoSvc.getAllCursos();
  }

}
